/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';

interface VisualWorkflowBuilderV2BulkMoveWarningModalArgs {
  campaign: CampaignModel;
  bulkMoveDelayActionIds: string[];
  bulkMoveTotalDelaySubjectsCount: number;
  confirmBulkMove: () => unknown;
  onClose: () => unknown;
  hasReadOnlyPermission: boolean;
}

export default class VisualWorkflowBuilderV2BulkMoveWarningModal extends Component<VisualWorkflowBuilderV2BulkMoveWarningModalArgs> {}
